import React from "react";
import {Helmet, HelmetProvider} from 'react-helmet-async';


export default function MetaTags(props) {

    return (
        <HelmetProvider>
            <Helmet>
                <meta charSet="utf-8"/>
                <meta name="viewport" content="width=device-width"/>
            </Helmet>
        </HelmetProvider>
    )

}